<template>
  <div>

    <v-row>
      <v-col cols="12" md="12" style="text-align: center;">
        <v-row>
          <v-col cols="12" md="12" style="text-align: center;">
            <v-img alt="Logo" class="shrink mr-2 app" contain :src="logoimage" transition="scale-transition"
              width="1000" />
          </v-col>
        </v-row>
        <v-sheet class="folded-corner" width="1045" height="1100" style="margin-top: 250px">
          <!-- เนื้อหา -->
          <v-container>
            <v-row style="margin-top: 3%;">

              <v-col cols="12" md="12" style="
                      text-align: center;
                      font-size: 60px;
                      color: #344054;
                      font-weight: bold;
                    ">

                {{ $t("message.PrivacyPolicy") }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12" style="text-align: left;">
                <PDPA />
              </v-col>
            </v-row>


          </v-container>
        </v-sheet>
      </v-col>
    </v-row>


    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center;">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear indeterminate color="#ffffff" class="mb-0"></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import axios from "axios";
import enurl from "@/api/environment";
// import ChangeLanguage from "@/components/ChangeLanguage";
import PDPA from "@/components/PDPA";
// import logoimage from "@/assets/OneBangkokLogo.png";
export default {
  name: "PDPAPage",
  components: {
    // ChangeLanguage,
    PDPA
  },



  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      logoimage: "",
    };
  },
  mounted: function () {
    // setInterval(() => {
    //   this.getCurrentDate();
    // }, 1000);
       this.logoimage = require("@/assets/OneBangkokLogo.png");
  },

  methods: {

    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    BackToMainPage() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    GotoIdentifySelection() {
      let self = this;
      self.$router.push("/Ocr");
    },
  },
};
</script>
<style scoped>
@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}

.invisible-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
